import { render, staticRenderFns } from "./CocukTeslimiAlacakForm.vue?vue&type=template&id=255ff2f1"
import script from "./CocukTeslimiAlacakForm.vue?vue&type=script&lang=ts"
export * from "./CocukTeslimiAlacakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports